import { Component, input } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { AufgabenTyp } from '@schir-int-client/aufgabe-shared';
import { NotizInAufgabeEditorComponent } from '../notiz-in-aufgabe-editor/notiz-in-aufgabe-editor.component';

@Component({
	selector: 'schir-int-client-aufgabe-with-notiz-editor',
	templateUrl: './aufgabe-with-notiz-editor.component.html',
	styleUrl: './aufgabe-with-notiz-editor.component.scss',
	imports: [ReactiveFormsModule, MatInputModule, NotizInAufgabeEditorComponent],
})
export class AufgabeWithNotizEditorComponent {
	readonly aufgabenTyp = input.required<AufgabenTyp>();
}
